// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__3uAXW","whiteColor":"Tag_whiteColor__2d7Vi","primaryColor":"Tag_primaryColor__26YPD"};